module.exports = __webpack_public_path__ + "static/img/banner4.435c87a8.png";